import range from "lodash/range";
import { getMonth, getYear } from "date-fns";
import { months } from "../../../constants";

const ReactDatePickerHeader = ({
  date,
  changeYear,
  isOnlyYearPicker = false,
  changeMonth,
  decreaseMonth,
  increaseMonth,
  decreaseYear, 
  increaseYear,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
}) => {
  const years = range(1970, getYear(new Date()) + 100, 1);

  return (
    <div className="d-flex justify-content-between w-100">
      <span
        onClick={isOnlyYearPicker ? decreaseYear : decreaseMonth}
        className="custom-date-picker-nav"
        disabled={prevMonthButtonDisabled}
      >
        {"<"}
      </span>
      {!isOnlyYearPicker && (
        <select
          value={months[getMonth(date)]}
          className="custom-date-picker-dropdown"
          onChange={({ target: { value } }) =>
            changeMonth(months.indexOf(value))
          }
        >
          {months.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      )}

      {!isOnlyYearPicker && (
        <select
          value={getYear(date)}
          className="custom-date-picker-dropdown"
          onChange={({ target: { value } }) => changeYear(value)}
        >
          {years.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      )}
      {isOnlyYearPicker && (
        <div className="d-flex justify-content-center align-items-center">
          {years[0]} - {years[years.length - 1]}
        </div>
      )}
      <span
        onClick={isOnlyYearPicker ? increaseYear : increaseMonth}
        className="custom-date-picker-nav"
        disabled={nextMonthButtonDisabled}
      >
        {">"}
      </span>
    </div>
  );
};

export default ReactDatePickerHeader;
